export default {
    functional: true,

    name: 'DividerLine',

    props: {
        direction: {
            type: String,
            default: 'horizontal',
            validator(val) {
                return ['horizontal', 'vertical'].indexOf(val) !== -1;
            }
        },

        contentPosition: {
            type: String,
            default: 'center',
            validator(val) {
                return ['left', 'center', 'right'].indexOf(val) !== -1;
            }
        },
        customStyle: {
            type: String,
            default: ''
        }
    },

    render(h, context) {
        const $slots = context.slots();
        const { direction, contentPosition, customStyle } = context.props;
        return (
            <div class={['el-divider', `el-divider--${direction}`]} style={`${customStyle}`}>
        {
            $slots.default && direction !== 'vertical'
                ? <div class={['el-divider__text', `is-${contentPosition}`]}>{$slots.default}</div>
        : null
        }
        </div>
    );
    }
};



// WEBPACK FOOTER //
// ./src/components/render/DividerLine.js